import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import "../../../assets/css/admin/allAdmins.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const ViewQuestion = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [question, setQuestion] = useState('');
  const params=useParams()
  const getQuestion = () => {
    axios
      .get(`${baseUrl}/question/get?id=${params.id}`)
      .then((res) => setQuestion(res.data))
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    getQuestion();
  }, []);


  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link className="text-decoration-none">Questions</Link>
              </li>
              <li className="breadcrumb-item active">
                View
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div
          className="container"
          style={{ backgroundColor: "white", padding: "40px" }}
        >
          <h4 className="mb-4"> View Question</h4>
          <div className="mt-4">
           { question.question&&<div
              className="question-preview"
              dangerouslySetInnerHTML={{ __html: question.question.question }}
            />}
          </div>
          <div className="mt-4">
            {question.question&&<div
              className="question-preview"
              dangerouslySetInnerHTML={{ __html: question.question.solution }}
            />
          }
          </div>
        </div>
      </main>
    </div>
  );
};

export default ViewQuestion;
